import { Routes, Route } from 'react-router-dom'
import type { RouteObject } from 'react-router-dom'
import { ShareToast } from '@/components/AuditShareCard'
import ComingSoon from '@/pages/ComingSoon'

// ─── Toggle this flag to enable/disable the Coming Soon page ───
// Set to `true`  → visitors see the Coming Soon page only
// Set to `false` → full website is shown as normal
const COMING_SOON_MODE = true
import Home from '@/pages/Home'
import Projects from '@/pages/Projects'
import ProjectDetail from '@/pages/ProjectDetail'
import Pricing from '@/pages/Pricing'
import Dashboard from '@/pages/Dashboard'
import AuthPage from '@/pages/Auth'
import Contact from '@/pages/Contact'
import NotFound from '@/pages/NotFound'
import AdminPage from '@/pages/Admin'

export const routes: RouteObject[] = [
  { path: '/',             element: <Home /> },
  { path: '/projects',     element: <Projects /> },
  { path: '/projects/:id', element: <ProjectDetail /> },
  { path: '/pricing',      element: <Pricing /> },
  { path: '/dashboard',    element: <Dashboard /> },
  { path: '/auth',         element: <AuthPage /> },
  { path: '/contact',      element: <Contact /> },
  { path: '/admin',        element: <AdminPage /> },
  { path: '*',             element: <NotFound /> },
]

export default function App() {
  if (COMING_SOON_MODE) return <ComingSoon />

  return (
    <>
      <Routes>
        {routes.map((r) => (
          <Route key={r.path} path={r.path} element={r.element} />
        ))}
      </Routes>
      <ShareToast />
    </>
  )
}
